import styled, { css } from "styled-components";

const wrapperModifiers = {
  primary: (theme) => css`
    background-color: ${theme.colors.lineBlue};
  `,
  secondary: (theme) => css`
    background-color: ${theme.colors.grayThird};
  `,
};

export const Wrapper = styled.button`
  ${({
    theme,
    button = "primary",
    disabled,
    fontSize,
    height,
    width,
    minWidth,
  }) => css`
    width: ${width};
    min-width: ${minWidth};
    height: ${height};
    color: ${theme.colors.white};
    border-radius: 0.6rem;

    font-size: ${fontSize};
    line-height: 1.28;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: ${disabled ? "not-allowed" : "pointer"};

    ${!!button && wrapperModifiers[button](theme)};
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LabelWrapper = styled.div``;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 4px 4px 4px;
  & svg {
    font-size: 24px;
  }
`;
